/* eslint-disable react/jsx-no-bind */
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import PaginationRow from 'components/atoms/GefMui/PaginationRow';
import fetch from 'features/common/fetch';
import { loadMore, loadPage } from 'features/views/marketPlace/actions';
import { getInProgressLeadsByTaskTypeId } from 'features/views/marketPlace/selectors';

import SubTableRowInProgressAndAfterDeadline from './SubTableRowInProgressAndAfterDeadline';

export const SubTableInProgressAndAfterDeadline = ({ taskTypeId }) => {
	const dispatch = useDispatch();

	const inProgressLeadsOfChosenTaskTypeId = useSelector((state) => getInProgressLeadsByTaskTypeId(state, taskTypeId));

	const hasRecords = !isNilOrEmpty(inProgressLeadsOfChosenTaskTypeId);
	const fetchStorePath = `${fetch.constants.urls.leadsList}.inProgressAndAfterDeadline.${taskTypeId}`;

	const handleLoadMore = useCallback(() => {
		dispatch(loadMore({ fetchStorePath, taskTypeId }));
	}, [dispatch, fetchStorePath, taskTypeId]);

	const handlePaginationClick = useCallback(
		(e, page) => {
			dispatch(loadPage({ fetchStorePath, taskTypeId, page: page - 1 }));
		},
		[dispatch, fetchStorePath, taskTypeId],
	);

	return (
		<Table size="small">
			<TableHead>
				<TableRow
					sx={(theme) => ({
						backgroundColor: theme.palette.grey[200],
						'.MuiTableCell-root': {
							fontWeight: 500,
						},
					})}
				>
					<TableCell width={65} />
					<TableCell width={250}>{getLabelMessage('marketPlace:fullNameOrBussinessName')}</TableCell>
					<TableCell>{getLabelMessage('marketPlace:municipality')}</TableCell>
					<TableCell>{getLabelMessage('marketPlace:zipCode')}</TableCell>
					<TableCell>{getLabelMessage('marketPlace:phone')}</TableCell>
					<TableCell>{getLabelMessage('marketPlace:email')}</TableCell>
					<TableCell>{getLabelMessage('marketPlace:processed')}</TableCell>
					<TableCell />
					<TableCell />
				</TableRow>
			</TableHead>
			<TableBody>
				{hasRecords &&
					inProgressLeadsOfChosenTaskTypeId.map((item) => (
						<SubTableRowInProgressAndAfterDeadline item={item} />
					))}
				<TableRow>
					<PaginationRow
						fetchStorePath={fetchStorePath}
						colSpan={100}
						onLoadNext={handleLoadMore}
						onPaginationClick={handlePaginationClick}
						noTableFooter
					/>
				</TableRow>
			</TableBody>
		</Table>
	);
};

SubTableInProgressAndAfterDeadline.propTypes = {
	taskTypeId: PropTypes.number,
};

export default SubTableInProgressAndAfterDeadline;
